module.exports = __webpack_public_path__ + "static/Gilroy-Bold-d6bc0c63d08e294d28714185a7dfcf03.woff";